export default __webpack_public_path__ + "img/loading.4a99836a.gif";